import { useCallback, useRef, useState } from "react";

import api from "@helpers/api";

import { defaultActivity } from "../enums/exerciseOptions";

export default function usePublishPost({ modalRef }) {
    const configRef = useRef({});
    const communityRef = useRef({});
    const callbackRef = useRef();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [exerciseRegistry, setExerciseRegistry] = useState(false);
    const [uploadBusyCount, setUploadBusyCount] = useState(0);

    const handleUploadBusyChange = useCallback((uploading) => {
        setUploadBusyCount((c) => Math.max(0, c + (uploading ? 1 : -1)));
    }, []);

    modalRef.current = {
        open(preFill, callback) {
            const { community, ...rest } = preFill || {};

            configRef.current = {
                ...rest,
                activity: { ...defaultActivity },
            };
            communityRef.current = community ? { ...community } : {};
            callbackRef.current = callback;
            setExerciseRegistry(false);
            setUploadBusyCount(0);
            setOpen(true);
        },
    };

    function buildPayload() {
        const payload = {
            text: configRef.current.text,
            image: configRef.current.photo,
            visibility: "public",
        };

        if (exerciseRegistry) {
            payload.activity = {
                duration: configRef.current.activity.duration,
                intensity: configRef.current.activity.intensity,
                mode: configRef.current.activity.mode,
            };
        }

        return payload;
    }

    async function handleSubmit() {
        try {
            setLoading(true);
            const groupId = configRef.current.group;
            const { data } = await api.post(
                `community/group/${groupId}/post`,
                buildPayload()
            );

            if (data?.id) {
                await callbackRef.current?.(data);
                setOpen(false);
            }
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    }

    return {
        open,
        loading,
        configRef,
        communityRef,
        exerciseRegistry,
        setExerciseRegistry,
        uploadBusy: uploadBusyCount > 0,
        handleUploadBusyChange,
        handleSubmit,
        handleClose: () => setOpen(false),
    };
}
